import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { getProjecById } from "../datasource/supabase";

export function useActiveDeal(explicitDealId?: string) {
  const params = useParams<{ id?: string; dealId?: string }>();
  const dealId = explicitDealId ?? params.id ?? params.dealId ?? null;

  const [deal, setDeal] = useState<any | undefined>(undefined);
  const [status, setStatus] = useState<
    "loading" | "ready" | "missingId" | "notFound"
  >("missingId");

  useEffect(() => {
    if (!dealId) {
      setStatus("missingId");
      setDeal(undefined);
      return;
    }

    setStatus("loading");
    setDeal(undefined);

    let isActive = true;

    const loadDeal = async () => {
      try {
        const loadedDeal = await getProjecById(dealId);

        if (!isActive) return;

        if (loadedDeal) {
          setDeal(loadedDeal);
          setStatus("ready");
        } else {
          setStatus("notFound");
        }
      } catch (error) {
        console.error("Failed to load deal:", error);
        if (isActive) {
          setStatus("notFound");
        }
      }
    };

    void loadDeal();

    return () => {
      isActive = false;
    };
  }, [dealId]);

  return { dealId, deal, status };
}
